<template>
	<div class="height-100dvh">
		<header class="mob-back-header">
			<img
				class="mr-3"
				@click="gobackmobile()"
				src="../../assets/mobile/assprog/mobileBackArrow.svg"
				alt=""
			/>
			View Mock Interview Reports
		</header>
		<main class="airep-interview-container">
			<div id="hideinmobile" class="cand-header d-flex mb-2">
				<img
					class="mr-3 d-flex pointer"
					src="../../assets/img/homepage/back-arrow-blue.svg"
					alt=""
					@click="goback()"
				/>
				View Mock Interview Reports
			</div>
			<div class="airep-container">
				<div class="d-flex header">
					<div
						class="candash-resume-tabs-pos-1"
						:class="
							selectedTab === 'all'
								? 'candash-resume-sel'
								: 'candash-resume-unsel'
						"
						@click="changeTab('all')"
					>
						All Interview
						<div v-if="selectedTab === 'all'" class="graph-sel-tab"></div>
					</div>

					<div
						class="candash-resume-tabs-pos-2"
						:class="
							selectedTab === 'skill'
								? 'candash-resume-sel'
								: 'candash-resume-unsel'
						"
						@click="changeTab('skill')"
					>
						Skill Interview
						<div v-if="selectedTab === 'skill'" class="graph-sel-tab"></div>
					</div>

					<div
						class="candash-resume-tabs-pos-2 more-width"
						:class="
							selectedTab === 'company'
								? 'candash-resume-sel'
								: 'candash-resume-unsel'
						"
						@click="changeTab('company')"
					>
						Company/Role Interview
						<div v-if="selectedTab === 'company'" class="graph-sel-tab"></div>
					</div>
				</div>
				<div class="airep-horizontal-scroll">
					<div id="hideinmobile" class="airep-header min-width-1200">
						<span class="col-one"
							>Interview Name
							<template v-if="filterColumn == 'interviewName'">
								<img
									v-show="toggleFilter"
									class="pointer"
									src="../../assets/newdesign/transaction/upsort.svg"
									alt=""
									@click="filterByDesc('interviewName')"
								/>
								<img
									v-show="!toggleFilter"
									class="pointer"
									src="../../assets/newdesign/transaction/downsort.svg"
									alt=""
									@click="filterByAsc('interviewName')"
								/>
							</template>
							<img
								v-else
								class="pointer"
								src="../../assets/newdesign/transaction/nosort.svg"
								alt=""
								@click="filterByAsc('interviewName'), (enableColSort = true)"
							/>
						</span>
						<span class="col-two"
							>Date & Time
							<template v-if="filterColumn == 'startedAt'">
								<img
									v-show="toggleFilter"
									class="pointer"
									src="../../assets/newdesign/transaction/upsort.svg"
									alt=""
									@click="filterByDesc('startedAt')"
								/>
								<img
									v-show="!toggleFilter"
									class="pointer"
									src="../../assets/newdesign/transaction/downsort.svg"
									alt=""
									@click="filterByAsc('startedAt')"
								/>
							</template>
							<img
								v-else
								@click="filterByAsc('startedAt'), (enableColSort = true)"
								class="pointer"
								src="../../assets/newdesign/transaction/nosort.svg"
								alt="" /></span
						><span class="col-three"
							>Total Duration
							<template v-if="filterColumn == 'duration'">
								<img
									v-show="toggleFilter"
									class="pointer"
									src="../../assets/newdesign/transaction/upsort.svg"
									alt=""
									@click="filterByDesc('duration')"
								/>
								<img
									v-show="!toggleFilter"
									class="pointer"
									src="../../assets/newdesign/transaction/downsort.svg"
									alt=""
									@click="filterByAsc('duration')"
								/>
							</template>
							<img
								v-else
								class="pointer"
								src="../../assets/newdesign/transaction/nosort.svg"
								alt=""
								@click="
									filterByAsc('duration'), (enableColSort = true)
								" /></span
						><span class="col-four">Status</span
						><span class="col-five">Action</span>
					</div>

					<section class="airep-scroll-2 min-width-1200" @scroll="onScroll">
						<div
							class="airep-horizontal-scroll h-100"
							v-if="
								mockinterviewDetails &&
								mockinterviewDetails.length == 0 &&
								!interviewReportLoading
							"
						>
							<div
								class="d-flex flex-column align-items-center justify-content-center no-airep-height h-100"
							>
								<img src="../../assets/img/mocknodata.svg" alt="" />
								<h4 class="fam-lato fw-LM fs-16 text-tertiary mt-4">
									No Records found
								</h4>
							</div>
						</div>
						<template v-if="interviewReportLoading && !loadingMore">
							<article
								v-for="i in 10"
								:key="i"
								class="airep-row fam-lato fw-R fs-15 text-blue"
							>
								<div id="hideinmobile" class="airep-blue-bar"></div>
								<section v-for="i in 4" :key="i" class="col-one">
									<b-skeleton class="w-75"></b-skeleton>
								</section>

								<div class="airep-wid-28 d-flex align-items-center">
									<section class="col-six w-25">
										<b-skeleton class="w-75"></b-skeleton>
									</section>
									<section class="col-sev w-25">
										<b-skeleton class="w-75"></b-skeleton>
									</section>
								</div>
								<div id="hideinlaptop" class="d-flex mt-2">
									<div class="width-45">
										<h5 class="fam-mont fw-LM fs-11 text-3A3C40 mb-1">
											Role Name
										</h5>
										<h5
											class="fam-mont fw-M fs-11 text-3A3C40 mb-1 w95 text-truncate"
										>
											<b-skeleton class="w-75"></b-skeleton>
										</h5>
									</div>
									<div class="width-45">
										<h5 class="fam-mont fw-LM fs-11 text-3A3C40 mb-1">
											Skills:
										</h5>
										<h5
											class="fam-mont fw-M fs-11 text-3A3C40 mb-1 w-100 text-truncate"
										>
											<b-skeleton class="w-100"></b-skeleton>
										</h5>
									</div>
								</div>
								<section id="hideinmobile" class="col-eig">
									<b-skeleton class="w-75"></b-skeleton>
								</section>
							</article>
						</template>
						<template v-else>
							<article
								v-for="(i, index) in mockinterviewDetails"
								:key="index"
								class="airep-row fam-lato fw-R fs-15 text-blue"
							>
								<div id="hideinmobile" class="airep-blue-bar"></div>
								<section
									class="col-one text-truncate pr-2"
									v-b-tooltip.hover="{ title: i.interviewName }"
								>
									{{ i.interviewName }}
								</section>
								<section id="hideinmobile" class="col-two">
									{{ formatDateTime(i.startedAt) }}
								</section>

								<section id="hideinmobile" class="col-three text-truncate pr-2">
									<span
										:class="
											i == 2
												? 'text-red'
												: i.status === 'aborted'
												? 'color-aborted'
												: ''
										"
										>{{ i.durationText || "-" }}</span
									>
								</section>
								<section id="hideinmobile" class="col-four">
									<span
										class="text-capitalize"
										:class="
											i.status === 'running'
												? 'color-F9C82B'
												: i.status === 'aborted'
												? 'color-aborted'
												: 'text-green'
										"
										>{{
											i.status === "running" ? "In-Progress" : i.status
										}}</span
									>
								</section>
								<section class="hideinlaptop" style="flex-direction: column">
									<div
										class="d-flex align-items-center justify-content-between w-100 mt-2"
									>
										<div class="d-flex align-items-center fam-mont fw-LM fs-13">
											<img
												class="mr-2"
												src="../../assets/img/aiInterview/clock.svg"
												alt=""
											/>
											<span class="text-red">
												<span :class="i == 2 ? 'text-red' : ''">{{
													i.durationText || "-"
												}}</span></span
											>
											<div
												style="
													height: 20px;
													width: 1px;
													background-color: #9eb3c6;
												"
												class="mx-2"
											></div>
											<span
												class="text-capitalize"
												:class="
													i.status === 'running'
														? 'color-F9C82B'
														: i.status === 'aborted'
														? 'color-aborted'
														: 'text-green'
												"
												>{{
													i.status === "running" ? "In-Progress" : i.status
												}}</span
											>
										</div>
										<div class="fam-mont fw-LM fs-12 text-lightgrey">
											{{ formatDateTime(i.startedAt) }}
										</div>
									</div>
									<div
										style="border-bottom: 2px dashed #d8d8d8; height: 15px"
										class="mb-3 w-100"
									></div>
								</section>
								<section class="col-five pr-3">
									<div class="buttons">
										<div class="mob-cancelBtn w-50">
											<b-button class="w-100" @click="reTakeInterview(i)"
												>Re-take Interview</b-button
											>
										</div>
										<div
											@click="
												i.status == 'running'
													? ''
													: gotoparticularMockInterviewReportPage(i.interviewID)
											"
											class="mob-addBtn position-relative w-50"
										>
											<b-button class="w-100" :disabled="i.status == 'running'"
												>View Report</b-button
											>
											<!-- <div v-if="buttonLoader" class="loader-pos-new">
											<Loader />
										</div> -->
										</div>
									</div>
								</section>
								
							</article>
							<div
								v-if="loadingMore"
								class="d-flex justify-content-center py-2"
							>
								<b-spinner label="Loading..."></b-spinner>
							</div>
						</template>
					</section>
					<div
						id="hideinmobile"
						class="acs-paginaTion-new d-flex justify-content-between align-items-center min-width-1200"
						v-if="total > 0"
					>
						<div class="d-flex">
							<span class="acs-gotopage-text mr-2 p-1">Go to page</span>
							<div class="acs-pagination-num">
								<b-form-input
									class="no-number"
									type="number"
									v-model="goToPage"
									@keydown="validateNumber"
									@keyup.enter="isValidPage(goToPage) && goToPages(goToPage)"
								>
								</b-form-input>
							</div>
							<div class="acs-pagination-addbtn">
								<b-button
									@click="goToPages(goToPage)"
									:disabled="!isValidPage(goToPage)"
								>
									<img
										src="../../assets/newdesign/assessPro/page-arrow.svg"
										alt=""
									/>
								</b-button>
							</div>
						</div>
						<div class="d-flex justify-content-center pagination ml-135">
							<b-pagination
								align="center"
								first-number
								last-number
								limit="4"
								v-model="page"
								@input="getmockInterviewData()"
								:total-rows="total"
								:per-page="pageCount"
							>
								<template #prev-text
									><span
										><img
											src="../../assets/newdesign/assessPro/pageLeft.svg"
											alt=""
										/> </span
								></template>
								<template #next-text
									><span
										><img
											src="../../assets/newdesign/assessPro/pageRight.svg"
											alt="" /></span
								></template>
							</b-pagination>
						</div>
						<div class="d-flex align-items-center">
							<PaginationCountSelect
								:pagecount="pageCount"
								@update-value="getPageCount"
							/>
							<div
								class="acs-gotopage-text mr-2 ml-4 d-flex align-items-center justify-content-end"
							>
								Results :
								<span class="ml-1">{{ pageStart }}</span>
								<span class="ml-1"> - {{ pageEnd }} </span>
								<span class="pl-1"></span> of <span class="pr-1"></span
								>{{ total }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</main>
		<PaymentComingSoonModal :showModal.sync="showPaymentComingSoonModal" />
	</div>
</template>

<script>
import { getmockInterviewData, getProfileSkills } from "@/utils/apiFunctions";
import PaginationCountSelect from "@/components/PaginationCountSelect.vue";
import PaymentComingSoonModal from "@/views/MyProfile/PaymentComingSoonModal.vue";

export default {
	data() {
		return {
			page: 0,
			type: 1,
			pageCount: 10,
			goToPage: null,
			pageEnd: 0,
			pageStart: 0,
			totalPages: null,
			mockinterviewDetails: [],
			selectedTab: "all",
			filterColumn: "",
			order: "desc",
			toggleFilter: false,
			enableColSort: false,
			interviewReportLoading: false,
			loadingMore: false,
			isLaptop: false,
			mockInterviewTaken: 0,
			showPaymentComingSoonModal: false,
			loadingMore: false,
			isLaptop: false,
		};
	},
	mounted() {
		this.checkScreenSize(); // Check screen size initially
		window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
	},
	components: {
		PaginationCountSelect,
		PaymentComingSoonModal,
	},
	created() {
		console.log("this.$route.query", this.$route.query);

		this.selectedTab = this.$route.query.tab || "all";
		this.getmockInterviewData();
		this.fetchProfileAndCompanySkills();
	},
	methods: {
		goback() {
			if (this.$route.query.from === "kickstart") {
				this.$router.go(-1);
				return;
			}
			this.$router.push({
				path: "/interviewskill",
				query: this.$route.query,
			});
		},
		gobackmobile() {
			if (this.$route.query.from === "kickstart") {
				this.$router.go(-1);
				return;
			}
			this.$router.push({ path: "/interviewskill", query: this.$route.query });
		},
		async fetchProfileAndCompanySkills() {
			try {
				this.loadingSkills = true;
				const resp = await getProfileSkills();
				if (resp.status === 200) {
					const allResp = resp.data.data.data;
					this.mockInterviewTaken = allResp.mock_interview_taken;
					console.log("this.mockInterviewTaken", this.mockInterviewTaken);
				}
			} catch (error) {
				console.error(error);
			} finally {
				this.loadingSkills = false;
			}
		},
		reTakeInterview(data) {
			let query = { fromAiInterview: true };

			// Uncomment in production
			// if (this.mockInterviewTaken >= 2) {
			// 	this.showPaymentComingSoonModal = true;
			// 	return;
			// }

			this.$store.commit(
				"candidateVUEX/setSelectedSkillsForInterview",
				data.config.skills
			);
			if (data.config.basedOn == "skill") {
				this.$store.commit("candidateVUEX/setSelectedCompany", {});
			} else {
				this.$store.commit("candidateVUEX/setSelectedCompany", {
					company_name: data.config.company,
					role: data.config.role,
				});
				query.bycompany = true;
			}
			this.$router.push({ name: "systemcheck", query: query });
		},
		filterByAsc(filterBy) {
			console.log("came");

			this.order = "asc";
			this.toggleFilter = !this.toggleFilter;
			this.filterColumn = filterBy;
			this.getmockInterviewData();
		},
		filterByDesc(filterBy) {
			this.order = "desc";
			this.toggleFilter = !this.toggleFilter;
			this.filterColumn = filterBy;
			this.getmockInterviewData();
		},
		isValidPage(page) {
			return /^\d*$/.test(page) && page > 0 && page <= this.totalPages;
		},
		getPageCount(val) {
			this.pageCount = val;
			this.page = 1;
			this.getmockInterviewData();
		},
		goToPages(pageNumberToGo) {
			console.log("pageNumberToGo", pageNumberToGo);
			this.page = pageNumberToGo;
			this.getmockInterviewData();
		},
		validateNumber(event) {
			if (["e", "E", "+", "-"].includes(event.key)) {
				event.preventDefault();
			}
		},
		formatDateTime(dateStr) {
			if (!dateStr) return "";

			// Parse as UTC
			const utcDate = new Date(dateStr);

			// Convert to IST (+5:30)
			const istOffset = 5.5 * 60 * 60 * 1000;
			const istDate = new Date(utcDate.getTime() + istOffset);

			const day = String(istDate.getDate()).padStart(2, "0");
			const month = String(istDate.getMonth() + 1).padStart(2, "0");
			const year = istDate.getFullYear();

			let hours = istDate.getHours();
			const minutes = String(istDate.getMinutes()).padStart(2, "0");
			const ampm = hours >= 12 ? "PM" : "AM";

			hours = hours % 12 || 12;

			return `${day}.${month}.${year}, ${hours}:${minutes} ${ampm}`;
		},
		changeTab(type) {
			this.selectedTab = type;
			this.getmockInterviewData();
		},
		gotoparticularMockInterviewReportPage(interviewId) {
			
			const currentTab = this.$route.query.tab || "all";
			if (this.selectedTab !== currentTab) {
				this.$router.replace({
					path: "/mockinterviewreports",
					query: { ...this.$route.query, tab: this.selectedTab },
				});
			}
			this.$router.push({
				path: "/particularmockinterviewreport",
				query: {
					...this.$route.query,
					interviewId: interviewId,
					fromTab: this.selectedTab,
				},
			});
		},
		async getmockInterviewData() {
			try {
				this.loadingMore = true;
				this.interviewReportLoading = true;
				let payload = {
					count: this.pageCount,
					page: this.page ? this.page - 1 : 0,
					basedOn: this.selectedTab,
					sortBy: this.filterColumn,
					sortOrder: this.order,
				};

				const response = await getmockInterviewData(payload);
				if (response.status === 200) {
					this.interviewReportLoading = false;
					this.loadingMore = false;
					if (this.page != 1 && !this.isLaptop) {
						this.mockinterviewDetails = [
							...this.mockinterviewDetails,
							...response.data.data.details.data,
						];
					} else {
						this.mockinterviewDetails = response.data.data.details.data || [];
					}
					this.pageEnd = response.data.data.details.pageEnd;
					this.pageStart = response.data.data.details.pageStart;
					this.total = response.data.data.details.total;
					this.totalPages = Math.ceil(this.total / this.pageCount);
				}
			} catch (err) {
				this.interviewReportLoading = true;
				console.log("err", err);
			}
		},
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
		},
		checkbetween(x, min, max) {
			return x > min && x < max;
		},
		onScroll(e) {
			// Check if mobile view (adjust breakpoint as needed, e.g., 1028px matches your CSS)
			if (window.innerWidth > 1028) return;

			const { target } = e;
			if (
				Math.ceil(target.scrollTop) >=
					target.scrollHeight - target.offsetHeight - 10 && // Added buffer
				!this.loadingMore
			) {
				if (this.checkbetween(this.pageEnd, 0, this.total)) {
					this.loadingMore = true;
					this.page++;
					this.getmockInterviewData();
				}
			}
		},
	},
};
</script>

<style>
.airep-interview-container {
	background-color: #e9ecef;
	height: calc(100vh - 60px);
	padding: 15px 15px 15px 75px;
	top: 60px;
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
}
.airep-interview-container .cand-header {
	background-color: #20639b14;
}
.airep-container {
	height: calc(100vh - 148px);
	background: #ffffff;
	box-shadow: 0px 0px 14px 0px #c4c4c480;
	width: 100%;
	position: relative;
	overflow: hidden;
	border-radius: 5px;
}
.airep-container .header {
	border-bottom: 1px solid #dddddd;
	padding-left: 25px;
}
.airep-horizontal-scroll {
	width: 100%;
	overflow-x: auto;
	padding-inline: 20px;
	padding-bottom: 5px;
}
.airep-header {
	background-color: #e9f0f5;
	font-family: "Lato", sans-serif;
	font-weight: 600;
	font-size: 14px;
	color: #20639b;
	height: 45px;
	display: flex;
	align-items: center;
	margin-top: 14px;
	padding-left: 40px;
}
.min-width-1200 {
	width: 100%;
	min-width: 1200px;
}
.airep-scroll-2 {
	height: calc(100vh - 315px);
	min-height: 280px;
	overflow: auto;
}
.airep-row {
	background-color: #fcfcfc;
	box-shadow: 0px 4px 15px 0px #c4c4c480;
	border-radius: 4px;
	position: relative;
	width: 100%;
	height: 50px;
	display: flex;
	align-items: center;
	margin-top: 10px;
	padding-left: 40px;
}
.airep-header .col-one,
.airep-header .col-five,
.airep-row .col-one,
.airep-row .col-five {
	width: 32.5%;
}
.airep-header .col-three,
.airep-header .col-four,
.airep-row .col-three,
.airep-row .col-four {
	width: 10%;
}
.airep-header .col-two,
.airep-row .col-two {
	width: 15%;
}
.airep-blue-bar {
	background-color: #20639b;
	border-radius: 2px;
	width: 3px;
	height: 93%;
	position: absolute;
	left: 3px;
}
.candash-resume-tabs-pos-2.more-width {
	width: 190px;
}
.airep-horizontal-scroll .mob-addBtn .btn,
.airep-horizontal-scroll .mob-cancelBtn .btn {
	font-size: 13px;
	padding: 4px 15px;
}
.airep-horizontal-scroll .buttons {
	width: 100%;
	max-width: 450px;
	display: flex;
	gap: 20px;
}
@media (max-width: 1028px) {
	.airep-interview-container {
		background-color: #f5f9ff;
		height: calc(
			100dvh - (60px + env(safe-area-inset-top) + env(safe-area-inset-bottom))
		) !important;
		padding: 0px !important;
		overflow: auto !important;
		position: fixed !important;
		top: unset !important;
		display: unset !important;
	}
	.airep-container {
		display: flex;
		flex-direction: column;
		height: 100%;
		background: unset;
		border: unset;
		box-shadow: unset;
		width: 100%;
		position: relative;
		overflow: auto;
		border-radius: 5px;
		padding: 0px;
	}
	.airep-container .header {
		border-bottom: none;
		padding-left: 0px;
	}
	.airep-container .candash-resume-unsel,
	.airep-container .candash-resume-sel {
		font-size: 12px;
	}
	.airep-container .ats-unsel-tab {
		background-color: transparent;
	}
	.airep-horizontal-scroll {
		width: unset;
		overflow-x: unset;
		padding-inline: unset;
		padding-bottom: 20px;
		height: calc(100% - 55px);
	}
	.min-width-1200 {
		width: 100%;
		min-width: 100%;
	}
	.airep-row {
		display: block;
		padding-left: unset;
		height: fit-content;
		padding: 10px;
	}
	.airep-row .col-one,
	.airep-row .col-five {
		width: 100%;
		padding-right: unset !important;
	}
	.airep-scroll-2 {
		height: 100%;
		padding-inline: 15px;
	}
}
.color-F9C82B {
	color: #f9c82b;
}
.color-aborted {
	color: #e70016;
}
</style>
